import '../style.scss';
import React from 'react';
import Button from '~/components/button';
import GeniusModal from '~/components/genius_modal';
const DeleteProject = (props) => {
    const { onHide, handleDeleteProject } = props;
    return (React.createElement(GeniusModal, { isModalShowing: props.isVisible, alertForm: true, onHide: onHide, bodyContent: React.createElement(React.Fragment, null,
            React.createElement("label", { className: 'modal-input-label', htmlFor: 'Location' }, "Delete folder and all contents (including subfolders)?")), footerContent: React.createElement(Button, { className: 'modal-action-btn', primary: true, onClick: () => { onHide(); handleDeleteProject(); } }, "Delete") }));
};
export default DeleteProject;
